// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { object, oneOfType, string } from 'prop-types'
import { UpdatedLabeledRadioGroupWrapper } from './styles'

import {
  ErrorSimple,
  LabelSimple,
  LookupWrapper,
  UpdatedRadioGroup,
} from 'components/Form'

const UpdatedLabeledRadioGroup = (props) => {
  const {
    className,
    idRoot,
    label,
    lookup,
    meta,
    ...radioGroupProps
  } = props

  return (
    <UpdatedLabeledRadioGroupWrapper className={`updated-labeled-radio-group ${className}`}>
      <LabelSimple
        idRoot={idRoot}
        label={label} />
      <UpdatedRadioGroup
        className={'radio-group align-start'}
        {...radioGroupProps}
        idRoot={idRoot}
        meta={meta} />
      <LookupWrapper
        lookup={lookup} />
      <ErrorSimple
        error={meta.error}
        idRoot={idRoot} />
    </UpdatedLabeledRadioGroupWrapper>
  )
}

UpdatedLabeledRadioGroup.propTypes = {
  className: string,
  idRoot: string.isRequired,
  label: oneOfType([
    string,
    object,
  ]),
  lookup: oneOfType([
    string,
    object,
  ]),
  meta: object.isRequired,
}

UpdatedLabeledRadioGroup.defaultProps = {
  className: '',
}

export default UpdatedLabeledRadioGroup
